import React, { useContext, useState } from 'react';
import { Container, Tabs, Typography, Tab, Box, Button } from '@mui/material';
import {colorText} from "../App/theme";
import { AlertContext } from "../App/App";
import { CodeViewer } from "../Code/CodeViewer";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {useNavigate} from "react-router-dom";
import {getPlatform, isLinux, isMac} from "../utils";

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
};

const Code = ({ children }) => {
    const { setSystemAlert } = useContext(AlertContext);

    return (
        <CodeViewer
            style={{ paddingRight: '45px' }}
            setSystemAlert={setSystemAlert}
            source={children}
            noCopy={true}
            language={"bash"}
            limitedWidth={true}
            className="codeWrapperAPI"
        />
    );
};

const Configure = ({userProfile, setSystemAlert}) => {
    return (
        <>
            <Typography align="left">3. Login:</Typography>
            <Typography variant="body2" gutterBottom align="left">
                <Code>openkbs login</Code>
            </Typography>
        </>
    )
}

export const InstallCLI = ({ userProfile }) => {
    const platformIndex = ['linux', 'mac', 'windows'].indexOf(getPlatform())

    const [value, setValue] = useState(platformIndex || 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const navigate = useNavigate();

    const { setSystemAlert } = useContext(AlertContext);


    return (
        <Container style={{ color: colorText }}>
            <Typography variant="h4" gutterBottom>
                CLI Installation Guide
            </Typography>
            <Tabs value={value} onChange={handleChange} aria-label="Platform-specific installation tabs">
                <Tab label="Linux" />
                <Tab label="macOS" />
                <Tab label="Windows" />
            </Tabs>
            <br />
            <Typography align="left">The openkbs CLI tool is an interface for interacting with the openkbs ecosystem. It allows users to sign transactions securely and call any API endpoint within the ecosystem, including AI models, tools, and services.</Typography>
            <TabPanel value={value} index={0}>
                <Typography align="left">1. Download the Binary:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>wget -O ~/Downloads/openkbs https://downloads.openkbs.com/cli/linux/openkbs</Code>
                </Typography>
                <Typography align="left">2. Make Executable and Move to Make Globally Available:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>chmod +x ~/Downloads/openkbs && sudo mv ~/Downloads/openkbs /usr/local/bin/openkbs</Code>
                </Typography>
                <Typography variant="body2" gutterBottom align="left">
                    This command makes the binary executable and moves it to a directory included in your system's PATH, making it globally available from any terminal.
                </Typography>
                <br />
                <Configure {...{userProfile, setSystemAlert}} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Typography align="left">1. Download the Binary:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>curl -o ~/Downloads/openkbs https://downloads.openkbs.com/cli/macos/openkbs</Code>
                </Typography>
                <Typography align="left">2. Make Executable and Move to Make Globally Available:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>mkdir -p /usr/local/bin && chmod +x ~/Downloads/openkbs && sudo mv ~/Downloads/openkbs /usr/local/bin/openkbs</Code>
                </Typography>
                <Typography variant="body2" gutterBottom align="left">
                    This command makes the binary executable and moves it to a directory included in your system's PATH, making it globally available from any terminal.
                </Typography>
                <br />
                <Configure {...{userProfile, setSystemAlert}} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <Typography align="left">1. Download the Binary:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>Invoke-WebRequest -Uri "https://downloads.openkbs.com/cli/windows/openkbs.exe" -OutFile "$Env:USERPROFILE\Downloads\openkbs.exe"</Code>
                </Typography>
                <Typography align="left">2. Add to PATH to Make Globally Available:</Typography>
                <Typography variant="body2" gutterBottom align="left">
                    <Code>$Env:Path += ";$Env:USERPROFILE\Downloads"</Code>
                </Typography>
                <Typography variant="body2" gutterBottom align="left">
                    This command temporarily adds the download directory to your PATH. For permanent addition, manually add the directory to your system's environment variables.
                </Typography>
                <br />
                <Configure {...{userProfile, setSystemAlert}} />
            </TabPanel>


            <CopyToClipboard text={userProfile.walletPrivateKey}>
                <Button variant="text" fullWidth={true}
                        color={'secondary'}
                        onClick={() => navigate('/api/services')}>
                    Try OpenKBS Services
                </Button>
            </CopyToClipboard>
        </Container>
    );
};